// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    userId: z.string().min(1).max(128),
    latitude: z.number().nullable().optional(),
    longitude: z.number().nullable().optional(),
    updatedAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    userId: z.string().min(1).max(128),
    latitude: z.number().nullable(),
    longitude: z.number().nullable(),
    updatedAt: z.number(),
});
export const UserGeoLocations = Object.freeze({
    table: 'user_geo_locations',
    tableSingular: 'user_geo_location',
    fields: {
        tenantId: 'tenant_id',
        userId: 'user_id',
        latitude: 'latitude',
        longitude: 'longitude',
        updatedAt: 'updated_at',
    },
    fieldKeys: [
        'tenantId',
        'userId',
        'latitude',
        'longitude',
        'updatedAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
